import React from 'react'
import Container from '../components/Container';
import { ScrollFadeIn, ScrollFadeInStagger } from '../../../components/ScrollFadeIn';
import { TbAlertHexagon, TbCurrencyDollarOff, TbMessage2Check, TbShieldDollar } from 'react-icons/tb';
import { PiChartLineDown } from 'react-icons/pi';
import { BsSearchHeart } from 'react-icons/bs';
import { trackEvent } from '../../../helpers/mixpanel';
const didYouKnow = [
    {
        // name: 'Misaligned Advisor Incentives',
        name: 'Financial service companies can limit their advice to what makes them money,',
        description:
            ' such as high-commission insurance products or annuities, and may not help you with the important guidance you need.',
        icon: TbAlertHexagon,
    },
    {
        // name: 'Minimum Investment Barriers',
        name: 'Many financial advisors will only work with you when you have a minimum amount to invest.',
        description:
            ' They also require you to move your accounts to a place where they can manage them, and bill you each month for management fees.',
        icon: TbCurrencyDollarOff,
    },
    {
        // name: 'Costly Management Fees',
        name: 'Over time, even a small management fee eats away at your life savings,',
        description:
            ' generating lower investment returns in the long run.',
        icon: PiChartLineDown,
    },

]

const abundoFeatures = [
    {
        name: 'Advice on Everything.',
        description:
            ' Rather than focusing our advice on just investments or insurance, we advise you on everything related to your ability to earn, save, or spend money.  ',
        icon: TbMessage2Check,
    },
    {
        name: 'Keep Control of Your Money. ',
        description: 'You’ll always be in control of your own investments. We teach you how to invest for your unique situation and empower you to know why you’re investing for your future. ',
        icon: TbShieldDollar,
    },
    {
        name: 'Low, Transparent Pricing.',
        description: `You never have to worry about hidden fees and you’ll know exactly how much you are paying. The only fee we receive from you is your low, monthly subscription payment. `,
        icon: BsSearchHeart,
    },
];
const ProblemSolution = () => {
    return (
        <Container bgColor='bg-white'>
            <div className="overflow-hidden">
                <div className="">
                    <div className="grid grid-cols-1 gap-x-20 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                        <ScrollFadeIn>
                            <img
                                src="https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1707501176/Abundo%20Wealth%20Assets/pages/public-home/DidYouKnow_sylqbv.webp"
                                alt="Smiling young woman with curly hair speaking into a megaphone against blue background."
                                className="rounded-xl object-cover h-[300px] sm:h-[500px] lg:h-full ring-1 ring-gray-400/10"
                                width={2432}
                                height={1280}
                                aria-label="Did You Know Image"
                            />
                        </ScrollFadeIn>
                        <div className="lg:pr-8">
                            <div className="lg:max-w-lg font-lato">
                                <ScrollFadeIn>
                                    <p className="text-gray-800 heading-2" aria-label="Did You Know">
                                        Did You Know...
                                    </p>
                                </ScrollFadeIn>
                                <ScrollFadeIn>
                                    <p className="mt-6 text-xl leading-8 text-gray-600">
                                        Many financial advisors work inside a system that incentivizes them to put your needs second - even if they are "fiduciaries" or "fee-only".
                                    </p>
                                </ScrollFadeIn>
                                <ScrollFadeInStagger faster={false} className="mt-10 max-w-xl space-y-7 text-base leading-7 text-gray-800 lg:max-w-none">
                                    {didYouKnow.map((feature) => (
                                        <ScrollFadeIn key={feature.name}>
                                            <div className="flex" aria-label={feature.name}>
                                                <dt className="inline font-semibold text-xl text-gray-900">
                                                    <feature.icon className="flex mt-1 h-6 w-6 text-sky-blue-200" aria-hidden="true" />
                                                </dt>{' '}
                                                <dd className="text-lg text-gray-500 ml-3">
                                                    <span className="font-bold text-gray-800 text-lg">{feature.name}</span> {feature.description}
                                                </dd>
                                            </div>
                                        </ScrollFadeIn>
                                    ))}
                                </ScrollFadeInStagger>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="overflow-hidden mt-16 lg:mt-24 xl:mt-28 2xl:mt-36">
                <div className="">
                    <div className="grid grid-cols-1 gap-x-20 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                        <ScrollFadeIn className="lg:hidden">
                            <img
                                src="https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1707501369/Abundo%20Wealth%20Assets/pages/public-home/HowWereDifferent_pgo9jy.webp"
                                alt="Smiling young interracial couple in red and white shirts looking at each other affectionately against a bright orange background."
                                className="rounded-xl object-cover h-[300px] sm:h-[500px] ring-1 ring-gray-400/10"
                                width={2432}
                                height={1280}
                                aria-label="How We're Different Image"
                            />
                        </ScrollFadeIn>
                        <div className="lg:pr-8">
                            <div className="lg:max-w-lg font-lato">
                                <ScrollFadeIn>
                                    <p className="text-gray-900 heading-2" aria-label="What Makes Abundo Different">
                                        What Makes Abundo Different?
                                    </p>
                                </ScrollFadeIn>
                                <ScrollFadeIn>
                                    <p className="mt-6 text-xl leading-8 text-gray-600">
                                        We believe the best way to help you achieve your financial goals is without high fees or conflicts of interest.
                                    </p>
                                </ScrollFadeIn>
                                <dl>
                                    <ScrollFadeInStagger faster={false} className="mt-10 max-w-xl space-y-7 text-base leading-7 text-gray-800 lg:max-w-none">
                                        {abundoFeatures.map((feature) => (
                                            <ScrollFadeIn key={feature.name}>
                                                <div className="flex" aria-label={feature.name}>
                                                    <dt className="inline font-semibold text-xl text-gray-900">
                                                        <feature.icon className="mt-1 h-6 w-6 text-sky-blue-200" aria-hidden="true" />
                                                    </dt>{' '}
                                                    <dd className="text-lg text-gray-600 ml-3">
                                                        <span className="font-bold text-gray-800 text-lg">{feature.name}</span> {feature.description}
                                                    </dd>
                                                </div>
                                            </ScrollFadeIn>
                                        ))}
                                    </ScrollFadeInStagger>
                                </dl>
                            </div>
                            <ScrollFadeIn>
                                <div className="">
                                    <a
                                        className="btn-4xl btn-secondary mt-10"
                                        href="/our-story"
                                        onClick={(e) => {
                                            trackEvent('pricing');
                                        }}
                                        aria-label="Learn More"
                                    >
                                        Learn More
                                    </a>
                                </div>
                            </ScrollFadeIn>
                        </div>
                        <ScrollFadeIn className="">
                            <img
                                src="https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1707501369/Abundo%20Wealth%20Assets/pages/public-home/HowWereDifferent_pgo9jy.webp"
                                alt="Smiling young interracial couple in red and white shirts looking at each other affectionately against a bright orange background."
                                className="hidden lg:flex rounded-xl object-cover h-full ring-1 ring-gray-400/10"
                                width={2432}
                                height={1280}
                                aria-label="How We're Different Image"
                            />
                        </ScrollFadeIn>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default ProblemSolution